








































































import {
  computed,
  ComputedRef,
  defineComponent,
  PropType,
  Ref,
  ref,
  toRefs,
} from "@vue/composition-api";
import useValores from "../composition/useValores";
import { Contenido } from "../models";
import autocompleteVue from "./contenidos/autocomplete.vue";
import formularioVue from "./contenidos/formulario.vue";
import listaVue from "./contenidos/lista.vue";
import ListaNavVue from "./lista/ListaNav.vue";

export default defineComponent({
  name: "Contenido",
  props: {
    contenido: {
      type: Object,
      required: true,
      // default value tratar de que sea Contenido
      default: () => {
        return {};
      },
    },
    rutas: Array as PropType<Array<string>>,
    query: Object,
    dialogData: Object,
    esDialogo: Boolean,
  },
  components: {
    Formulario: formularioVue,
    lista: listaVue,
    listaNav: ListaNavVue,
    Autocomplete: autocompleteVue,
  },
  setup(props, { emit, root }) {
    const { contenido, rutas, query } = toRefs(props);

    const contenidoComp: ComputedRef<Contenido> = computed(() => {
      const ruta = rutas.value?.[0];
      return contenido.value?.[ruta] || contenido.value || {};
    });

    const subrutas = computed(() => rutas.value.slice(1));

    const actualizar = (nombre, valor, reemplazar = true) => {
      console.log({ nombre, valor });
      const { $router } = root;
      const ubicacion = { query: { ...query.value, [nombre]: valor } };

      reemplazar ? $router.replace(ubicacion) : $router.push(ubicacion);
    };

    const emitirCerrar = (data) => {
      console.log("emitiendo cerrar");
      emit("cerrar", data);
    };

    const emitirAbrir = (valor) => {
      emit("abrir", valor);
    };

    const autocomplete = ref({
      "solo-inverted": true,
      flat: true,
      "hide-details": true,
      placeholder: "Buscar en Don Bosco",
      "prepend-inner-icon": "mdi-magnify",
      clearable: true,
    });

    const busqueda = computed(() => contenidoComp.value.busqueda)

    const buscar = (valor) => {
      const { nombre, seleccion } = busqueda.value

      if(typeof(valor) != "string" && seleccion){
        const { $router } = root;
        const { asignarDesdeObj } = useValores(valor)
        const { path, modelo } = seleccion
        const query = asignarDesdeObj(modelo)

        console.log("query a realizar:", { query })
        $router.push({ path, query })
      }
      else {
        actualizar(nombre, valor)
      }
    }

    return {
      contenidoComp,
      subrutas,
      actualizar,
      atributos: computed(() => contenidoComp.value.atributos || {}),
      emitirCerrar,
      emitirAbrir,
      autocomplete,
      buscar,
      busqueda
    };
  },
});
